import React, { useEffect, useMemo, useState } from "react";
import MasterService from "../services/master/MasterService";
import { formatRupiah } from "./Utils";

const TarifPnbp = ({ kdTarif, param }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [uraian, setUraian] = useState('')

    useEffect(() => {
        const getTarif = async () => {
            const response = await masterService.getTarifPnbpV2ByKode(kdTarif)
            if (param === 'nama') {
                setUraian(response.data.nmTarif)
            } else if (param === 'tarif') {
                setUraian(response.data.tarif)
            }
        }
        getTarif()
    }, [masterService, kdTarif, param])

    return (
        <>{param === 'nama' ? uraian : formatRupiah(uraian) }</>
    )
}

export default TarifPnbp